import React from "react";
import classes from "./Slide.module.css";
import * as contentTypes from './contentTypes'
import FileImg from '../assests/file-slide.png';
import ImgSlide from '../assests/img-slide.png';
import TinymceImg from '../assests/tintnce-slide.png';
import QuestioneImg from '../assests/quetion-slide.png';

const Slide = ({ onClick, bgImage, name, children, type, selected, dropClass }) => {

    const getContentImg = () => {
        switch (type) {
            case contentTypes.tinyMCE:
                return TinymceImg
            case contentTypes.file:
                return FileImg
            case contentTypes.quetion:
                return QuestioneImg
            case contentTypes.image:
                return ImgSlide
            default:
                break;
        }
    }
    return <div className={`${classes.Slide} ${selected && classes.Selected}`} onClick={onClick}>
        <div className={`${classes.SildePreview} ${dropClass}`} >
            <div className={classes.SildeIcon} style={{ backgroundImage: `url(${bgImage ? bgImage : getContentImg()})` }}> </div>
            <div className={classes.SildeName}>{name}</div>
        </div>
        {children}
    </div>
}
export default Slide;